import Tone from 'tone';
import MidiEffect from '../MidiEffect.js';
import ParameterContext from 'effects/ParameterContext.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import VariableEffect from './VariableEffect.js';

class ScriptingEffect extends VariableEffect(MidiEffect) {
    constructor(name, track) {
        super(name, track);
        this.myScript = () => [];
        this.isScript = true;
    }

    onNewStep() {
        this.triggers = [];
    }

    get currentStep() {
        return this.track.sequencerEngine.trackStep % this.track.length;
    }

    output(time, stepNumber=this.currentStep, actualStepNumber=this.currentStep) {
        try {
            this.currentTime = time;
            if (!time) {
                this.triggers.forEach(
                    t => t.stepNumber = actualStepNumber);
            }
            let ret = this.script(
                this.triggers,
                actualStepNumber,
                time,
                this);
            this.graphics = [];
            ret.forEach(({stepData, graphics}) => {
                if (stepData) {
                    if (!this._subSequence) {
                        stepData.track = this.track;
                    }
                }
                if (graphics) {
                    this.graphics.push(graphics);
                }
            });
            return ret;
        } catch (e) {
            return [];
        }
    }

    get script() {
        return this.myScript;
    }

    isRealTime() {
        return false;
    }
}

export default ScriptingEffect;
